<template>
  <el-dialog
    v-if="visible"
    :visible="visible"
    :title="title"
    show-close
    width="1000px"
    :close-on-click-modal="false"
    :before-close="() => close()"
    :modal-append-to-body="false"
    :modal="false"
  >
    <Main
      :shipmentCode="shipmentCode"
      @close="close()"
      @checkboxChange="(e) => (checkedRecords = e)"
    />
    <span slot="footer">
      <el-button size="small" @click="close()">
        {{ $l('INDEX.btn_close') || '关闭' }}
      </el-button>
      <el-button
        type="success"
        size="small"
        @click="exportRecords()"
        :disabled="checked"
      >
        {{ $l('INDEX.btn_export_by_booking_record') || '按订舱记录导出' }}
      </el-button>
      <el-button
        type="primary"
        size="small"
        @click="exportRecords()"
        :disabled="!checked"
      >
        {{ $l('INDEX.btn_export_selection_record') || '导出选择记录' }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import EditLoading from '@/mixins/edit-loading'
import Main from './main.vue'
export default {
  components: { Main },
  mixins: [EditLoading],
  props: {
    title: { type: String, default: '' },
    visible: { type: Boolean, default: false },
    shipmentCode: { type: String, default: '' },
  },
  data() {
    return {
      checkedRecords: [],
    }
  },
  computed: {
    checked() {
      return !!(this.checkedRecords && this.checkedRecords.length)
    },
  },
  methods: {
    close() {
      this.$emit('close')
      this.$emit('update:visible', false)
      this.checkedRecords = []
    },
    exportRecords() {
      const context = {
        shipmentCode: this.shipmentCode,
        listContainerCode: !this.checked
          ? []
          : this.checkedRecords.map((item) => item.shipmentContainerCode),
      }
      this.$emit('confirm', context)
    },
  },
}
</script>

<style scoped></style>
